﻿import { DataRequest } from 'shared/data/datarequest';

export class FieldIdentifier extends DataRequest {
    static $type = 'Web.FieldIdentifier';

    identifier: string;

    static create(identifier: string) {
        var x = new FieldIdentifier();

        x.$type = FieldIdentifier.$type;

        x.identifier = identifier;

        return x;
    }
}